"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENTITY_UID_REGEX = void 0;
exports.normalizeOptionalEntityUid = normalizeOptionalEntityUid;
exports.ENTITY_UID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
function normalizeOptionalEntityUid(value) {
    if (typeof value !== "string") {
        return undefined;
    }
    const trimmed = value.trim();
    if (!trimmed || !exports.ENTITY_UID_REGEX.test(trimmed)) {
        return undefined;
    }
    return trimmed;
}
